<div style="background-color: #9b7544 !important;">

  <link href="/assets/css/webflow.css" rel="stylesheet" type="text/css">
  <link href="/assets/css/petcart-vetpage.webflow.css" rel="stylesheet" type="text/css">
  <!-- [if lt IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/html5shiv/3.7.3/html5shiv.min.js" type="text/javascript"></script><![endif] -->
  <script type="text/javascript">!function(o,c){var n=c.documentElement,t=" w-mod-";n.className+=t+"js",("ontouchstart"in o||o.DocumentTouch&&c instanceof DocumentTouch)&&(n.className+=t+"touch")}(window,document);</script>



  <div data-collapse="medium" data-animation="default" data-duration="400" class="navbar w-nav"><a style="height: 150px; width: 150px;" href="#" class="brand w-nav-brand"><img src="/assets/images/logo.png"></a>
    <nav role="navigation" class="nav-menu w-nav-menu" style="    margin-left: 630px;">
	<a href="#benifits" class="nav-link w-nav-link">Benifits</a>
	<a href="#vision" class="nav-link w-nav-link">Vision &amp; Mission</a>
	<a href="/doctor/home" class="button w-button">Join Us</a></nav>
    <div class="w-nav-button">
      <div class="icon-2 w-icon-nav-menu"></div>
    </div>
  </div>
  <div class="section">
    <div>
      <div class="row w-row">
        <div class="column w-col w-col-6 w-col-small-6 w-col-tiny-tiny-stack">
          <h1 class="heading">Healthier pets<br>Happier Pet Parents</h1>
          <div class="div-block-6"></div>
          <p class="paragraph">PetCart aims to be a catalyst for the ever growing Indian Pet Industry. We aim to provide 360&#176; world class petcare services</p>
		  <a href="#"><img src="/assets/images/join-us1.png" class="image"></a></div>
        <div class="column-7 w-col w-col-6 w-col-small-6 w-col-tiny-tiny-stack"><img src="/assets/images/img.png" srcset="/assets/images/img-p-500.png 500w, /assets/images/img.png 551w" sizes="(max-width: 479px) 100vw, (max-width: 767px) 45vw, (max-width: 991px) 46vw, 37vw"></div>
      </div>
    </div>
  </div>
  <div class="section-2">
    <div class="div-block">
      <div id="benifits" class="row-2 w-row">

	    <a href="#" class="boldtrigger" id="benif1">
        <div class="column-2 w-col w-col-4 w-col-small-small-stack">
          <div class="div-block-2"><img src="/assets/images/d1.png"></div>
          <h4 class="heading-2">Manage customers</h4>
          <p class="paragraph-2">Manage your customers
effectively Sending them
vaccination reminders ,
geo fenced info on some
important info ,holidays,
change  in timings ,new
service info.</p>
        </div>
		</a>

		<a href="#" class="boldtrigger2" id="benif2">
        <div class="column-3 w-col w-col-4 w-col-small-small-stack">
          <div class="div-block-3"><img src="/assets/images/d2.png"></div>
          <h4 class="heading-2-2">Bringing more efficiency</h4>
          <p class="paragraph-2">Bringing more efficiency
appointment management ,
scan of records.
</p>
        </div>
		</a>

		<a href="#" class="boldtrigger3" id="benif3">
        <div class="column-4 w-col w-col-4 w-col-small-small-stack">
          <div class="div-block-4"><img src="/assets/images/d3.png"></div>
          <h4 class="heading-2-3">Virtual practice</h4>
          <p class="paragraph-2">Giving proper infra
to Telemedicine .
messaging chat and
video chat.</p>
        </div>
		</a>

      </div>
      <div class="row-2 _1 w-row">

	    <a href="#" class="boldtrigger4" id="benif4">
        <div class="column-2 w-col w-col-4">
          <div class="div-block-7"><img src="/assets/images/d4.png"></div>
          <h4 class="heading-2-4">Exposure to larger base</h4>
          <p class="paragraph-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla,</p>
        </div>
		</a>

		<a href="#" class="boldtrigger5" id="benif5">
        <div class="column-3 w-col w-col-4">
          <div class="div-block-9"><img src="/assets/images/d5.png"></div>
          <h4 class="heading-2-5">Contribute to growth</h4>
          <p class="paragraph-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla,</p>
        </div>
		</a>

		<a href="#" class="boldtrigger6" id="benif6">
        <div  class="column-4 w-col w-col-4">
          <div class="div-block-8"><img src="/assets/images/d6.png"></div>
          <h4 class="heading-2-6">Newer revenues</h4>
          <p class="paragraph-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla,</p>
        </div>
		</a>

      </div>
      <div class="w-row">

        <div id="benif1_1" class="column-9 w-clearfix w-col w-col-7">
          <h1 class="heading _2">There&#x27;s beauty <br>in simplicity</h1>
          <p class="paragraph _1">You can have an art experience <br> in front of a Rembrandt… or in front <br> of a piece of graphic design.</p>
          <div class="div-block-6 _1 w-hidden-tiny"></div>

		  <a href="#"><img src="/assets/images/jjoin-us.png" class="image-3"></a>
		</div>

		<div id="benif2_2" class="column-9 w-clearfix w-col w-col-7" style="display:none;">
          <h1 class="heading _2">There&#x27;s beauty <br>in simplicity</h1>
          <p class="paragraph _1">It’s through mistakes that <br> you actually can grow. You have to <br> get bad in order to get good.</p>
          <div class="div-block-6 _1 w-hidden-tiny"></div>
          <h4 class="heading-3 w-hidden-tiny">MORE EFFICIENCY</h4>
		  <a href="#"><img src="/assets/images/jjoin-us.png" class="image-3"></a>
		</div>

		<div id="benif3_3" class="column-9 w-clearfix w-col w-col-7" style="display:none;">
          <h1 class="heading _2">There&#x27;s beauty <br>in simplicity</h1>
          <p class="paragraph _1">But I find that for myself, without exception,  the more I deal with the work as something that is my own,
		                          as something that is personal, the more successful it is.</p>
          <div class="div-block-6 _1 w-hidden-tiny"></div>
          <h4 class="heading-3 w-hidden-tiny">VIRTUAL PRACTICE</h4>
		  <a href="#"><img src="/assets/images/jjoin-us.png" class="image-3"></a>
		</div>

		<div id="benif4_4" class="column-9 w-clearfix w-col w-col-7" style="display:none;">
          <h1 class="heading _2">There&#x27;s beauty <br>in simplicity</h1>
          <p class="paragraph _1">I want to make beautiful things,<br> even if nobody cares, as opposed to ugly things.<br> That’s my intent.</p>
          <div class="div-block-6 _1 w-hidden-tiny"></div>
          <h4 class="heading-3 w-hidden-tiny">LARGER BASE</h4>
		  <a href="#"><img src="/assets/images/jjoin-us.png" class="image-3"></a>
		</div>

		<div id="benif5_5" class="column-9 w-clearfix w-col w-col-7" style="display:none;">
          <h1 class="heading _2">There&#x27;s beauty <br>in simplicity</h1>
          <p class="paragraph _1">The life of a designer is a life of fight. Fight against the ugliness. Just like a doctor fights against
  		                      disease. For us, the visual disease is what we have around, and what we try to do is cure it somehow with design</p>
          <div class="div-block-6 _1 w-hidden-tiny"></div>
          <h4 class="heading-3 w-hidden-tiny">CONTRIBUTE TO GROWTH </h4>
		  <a href="#"><img src="/assets/images/jjoin-us.png" class="image-3"></a>
		</div>

		<div id="benif6_6" class="column-9 w-clearfix w-col w-col-7" style="display:none;">
          <h1 class="heading _2">There&#x27;s beauty <br>in simplicity</h1>
          <p class="paragraph _1">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus.</p>
          <div class="div-block-6 _1 w-hidden-tiny"></div>
          <h4 class="heading-3 w-hidden-tiny">NEWER REVENUES</h4>
		  <a href="#"><img src="/assets/images/jjoin-us.png" class="image-3"></a>
		</div>


        <div class="column-8 w-clearfix w-col w-col-5"><img src="/assets/images/img1.png" srcset="/assets/images/img1-p-500.png 500w, /assets/images/img1.png 536w" sizes="(max-width: 479px) 100vw, (max-width: 661px) 81vw, (max-width: 767px) 536px, (max-width: 991px) 37vw, 32vw" class="image-2 w-hidden-tiny"></div>
      </div>
      <div id="vision" class="div-block-10">
        <div class="div-block-11">
          <h1 class="heading _3">Vision of<br>Petcart</h1>
          <div class="div-block-6"></div>
          <p class="paragraph _3">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus.</p>
		  <a href="#"><img src="/assets/images/exploree.png"></a>
      </div>
    </div>


  </div>


  <script src="https://code.jquery.com/jquery-3.3.1.min.js" type="text/javascript" intergrity="sha256-FgpCb/KJQlLNfOu91ta32o/NMZxltwRo8QtmkMRdAu8=" crossorigin="anonymous"></script>
  <script src="js/webflow.js" type="text/javascript"></script>
  <!-- [if lte IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/placeholders/3.0.2/placeholders.min.js"></script><![endif] -->
</div>
